import { useState, useEffect } from "react";
import { getUserDetails } from "../../../../Service/userAQapi";
import { getAndroidDownloads } from "../../../../Service/getDashboard";
import { UserAuqisitation, CommonImages } from "../../../../reusableUI/images";
import moment from "moment";
import Card from "../../../../reusableUI/CommonCardUi";
import SmallCard from "../../../../reusableUI/smallCard";
import Chart from "../../../../Charts/highChart";
import CommonDropdown from "../../../../reusableUI/dropdown";
import ProgressBar from "../../../../reusableUI/progerssBar";
import UserGender from "../../../../Charts/userGender";
import GeneralRole from "../../../../Charts/userByRole";
import Loader from "../../../../reusableUI/loader";
// import CountryList from "../../reusableUI/countryList";
// import CountryList2 from "../../reusableUI/countryList2";
// import IndiaFlag from "../../assets/common/IN.png";
// import UsFlag from "../../assets/common/US.png";
// import Age from "../../../Charts/ageChart";

const Home = () => {
  const [card, setCard] = useState("1");
  const [loading, setLoading] = useState(true);
  const [timeframe, setTimeframe] = useState("Over All");
  const [userData, setUserData] = useState(null);
  const [iosData, setIosData] = useState([]);
  const [androidData, setAndroidData] = useState([]);
  const [nurseList, setNurseList] = useState([]);
  const [patientList, setPatientList] = useState([]);
  const [physioList, setPhysioList] = useState([]);
  // const [last30DaysUsers, setLast30DaysUsers] = useState([]);
  const [filteredNurseList, setFilteredNurseList] = useState([]);
  const [filteredPatientList, setFilteredPatientList] = useState([]);
  const [filteredPhysio, setFilteredPhysio] = useState([]);
  // const [downfilteredNurseList, setDownFilteredNurseList] = useState([]);
  // const [downfilteredPatientList, setDownFilteredPatientList] = useState([]);
  const [downfilteredIosList, setDownFilteredIosList] = useState([]);
  const [downfilteredAndroidList, setDownFilteredAndroidList] = useState([]);
  const [androidDownloads, setAndroidDownloads] = useState(0);
  const [androidDailyData, setAndroidDailyData] = useState([]);
  const [loadingAndroidDownloads, setLoadingAndroidDownloads] = useState(true);

  // Map timeframe to API format
  const getTimePeriodForAPI = (timeframe) => {
    switch (timeframe) {
      case "Last 7 days":
        return "last7days";
      case "Last 15 days":
        return "last15days";
      case "Last 30 days":
        return "last30days";
      case "Over All":
        return "alltime";
      default:
        return "alltime";
    }
  };

  // Fetch Android downloads from Google Play
  useEffect(() => {
    const fetchAndroidDownloads = async () => {
      try {
        setLoadingAndroidDownloads(true);
        const timePeriod = getTimePeriodForAPI(timeframe);
        const result = await getAndroidDownloads(timePeriod);
        if (result && !result.error && result.data) {
          setAndroidDownloads(result.data.android || 0);
          setAndroidDailyData(result.data.androidDaily || []);
          console.log(
            `Android downloads for ${timeframe}:`,
            result.data.android
          );
          console.log(`Android daily data:`, result.data.androidDaily);
        } else {
          console.error("Error fetching Android downloads");
          setAndroidDownloads(0);
          setAndroidDailyData([]);
        }
      } catch (error) {
        console.error("Error fetching Android downloads:", error);
        setAndroidDownloads(0);
        setAndroidDailyData([]);
      } finally {
        setLoadingAndroidDownloads(false);
      }
    };

    fetchAndroidDownloads();
  }, [timeframe]);

  //Getting the Data's from API : here
  useEffect(() => {
    const fetchUserCount = async () => {
      try {
        const result = await getUserDetails();
        if (!result.error) {
          setLoading(false);
          setUserData(result.data);
          let iosList = result?.data?.downloads.filter(
            (item) => item.platform === "ios"
          );
          let androidList = result?.data?.downloads.filter(
            (item) => item.platform === "android"
          );
          let nurseList = result?.data?.registeredUsers?.users.filter(
            (item) => item.role === "nurse"
          );
          let patientList = result?.data?.registeredUsers?.users.filter(
            (item) => item.role === "patient"
          );
          let physioList = result?.data?.registeredUsers?.users.filter(
            (item) => item.role === "physiotherapist"
          );

          setNurseList(nurseList);
          setPatientList(patientList);
          setPhysioList(physioList);
          setIosData(iosList);
          setAndroidData(androidList);
        } else {
          console.log("");
        }
      } catch (err) {
        console.log("");
      } finally {
        console.log("");
      }
    };

    fetchUserCount();
  }, []);

  useEffect(() => {
    const filterByDateRange = (list, timeRange) => {
      const today = moment().endOf("day");
      const last7Days = moment().subtract(6, "days").startOf("day");
      const last15Days = moment().subtract(14, "days").startOf("day");
      const last30Days = moment().subtract(29, "days").startOf("day");

      if (timeRange === "Last 7 days") {
        return list.filter((item) =>
          moment(item.dateTime).isBetween(last7Days, today, null, "[]")
        );
      } else if (timeRange === "Last 15 days") {
        return list.filter((item) =>
          moment(item.dateTime).isBetween(last15Days, today, null, "[]")
        );
      } else if (timeRange === "Last 30 days") {
        return list.filter((item) =>
          moment(item.dateTime).isBetween(last30Days, today, null, "[]")
        );
      } else if (timeRange === "Over All") {
        return list; // No filtering for "Over All"
      }
    };

    // Filter lists based on the selected time range
    // setDownFilteredNurseList(filterByDateRange(nurseList, timeframe));
    // setDownFilteredPatientList(filterByDateRange(patientList, timeframe));
    setDownFilteredIosList(filterByDateRange(iosData, timeframe));

    // For Android, use the daily data from Google Play API (already filtered by backend)
    setDownFilteredAndroidList(androidDailyData);
  }, [
    timeframe,
    nurseList,
    patientList,
    iosData,
    androidData,
    androidDailyData,
  ]);

  const usersList = [
    ...filteredNurseList,
    ...filteredPatientList,
    ...filteredPhysio,
  ];

  let totalForPlatform = androidDownloads + downfilteredIosList.length;

  const options = [
    { label: "Over All", value: "Over All" },
    { label: "Last 7 days", value: "Last 7 days" },
    { label: "Last 15 days", value: "Last 15 days" },
    { label: "Last 30 days", value: "Last 30 days" },
  ];

  useEffect(() => {
    const filterUsersByTimeframe = (users, timeframe) => {
      const now = new Date();
      let startDate;

      if (timeframe === "Last 7 days") {
        startDate = new Date(now.setDate(now.getDate() - 7)); // Last 7 days
      } else if (timeframe === "Last 15 days") {
        startDate = new Date(now.setDate(now.getDate() - 15)); // Last 15 days
      } else if (timeframe === "Last 30 days") {
        startDate = new Date(now.setDate(now.getDate() - 30)); // Last 30 days
      } else if (timeframe === "Over All") {
        return users; // No filtering, return full list for "Over All"
      }

      return users.filter((user) => new Date(user.createdAt) >= startDate);
    };

    const filteredNurses = filterUsersByTimeframe(nurseList, timeframe);
    const filteredPatients = filterUsersByTimeframe(patientList, timeframe);
    const filteredPhysiolist = filterUsersByTimeframe(physioList, timeframe);

    setFilteredNurseList(filteredNurses);
    setFilteredPatientList(filteredPatients);
    setFilteredPhysio(filteredPhysiolist);
  }, [timeframe, nurseList, patientList, physioList]);

  // const handleTimeframeChange1 = (value) => {
  //   console.log(value);
  //   setTimeframe(value);
  // };
  let total =
    filteredNurseList.length +
    filteredPatientList.length +
    filteredPhysio.length;

  const onClick = (c) => {
    setCard(c);
  };

  //dropdown timing here
  const handleTimeframeChange = (e) => {
    setTimeframe(e.target.value);
  };
  const segments = [
    {
      variant: "success",
      now: downfilteredIosList.length,
      color: "#17DEEB",
      striped: true,
    },
    {
      variant: "warning",
      now: androidDownloads,
      color: "#4951EC",
      striped: true,
    },
  ];

  const segments2 = [
    {
      variant: "success",
      now: filteredNurseList.length,
      color: "#9BDBA1",
      striped: true,
    },
    {
      variant: "warning",
      now: filteredPatientList.length,
      color: "#b474fc",
      striped: true,
    },
    {
      variant: "success",
      now: filteredPhysio.length,
      color: "#e58801",
      striped: true,
    },
  ];

  // console.log("U", patientList);
  return (
    <>
      {loading ? (
        <div>
          <Loader loading={loading} />
        </div>
      ) : (
        <div className="overflow-y-auto   bg-[#F3F6F5] w-full h-[85vh] mb-20 overflow-x-hidden ">
          <div className="flex flex-row justify-center items-center w-full max-w-full">
            <Card
              title={"Number of Downloads"}
              image={UserAuqisitation.downloads}
              image1={CommonImages.Up}
              count={
                loadingAndroidDownloads
                  ? "..."
                  : (androidDownloads + downfilteredIosList.length).toString()
              }
              text={
                loadingAndroidDownloads
                  ? "Fetching..."
                  : `${androidDownloads} from Play Store, ${downfilteredIosList.length} from App Store`
              }
              onClick={() => onClick("1")}
              page={"1"}
              id="1"
              user={"userAqu"}
              size="default"
              className="w-[300px] h-[200px]"
            />

            <Card
              title={"Registered Users"}
              image={UserAuqisitation.usersI}
              count={total.toString()}
              text={`${total} users for ${timeframe}`}
              onClick={() => onClick("2")}
              page={"2"}
              id="2"
              user={"userAqu"}
              size="default"
              className="w-[300px] h-[200px]"
            />
          </div>

          {card === "1" && (
            <div className=" h-screen ">
              <div className="bg-white mb-3 rounded-2xl shadow-md m-2">
                <div className="flex justify-between items-center m-2">
                  <div>
                    <p className="text-[14px] ml-5  font-semibold">
                      Number Of Downloads
                    </p>
                    <p className="text-[10px] ml-5 text-gray-500 italic">
                      Historical data from database
                    </p>
                  </div>

                  <CommonDropdown
                    options={options}
                    value={timeframe}
                    onChange={handleTimeframeChange}
                  />
                </div>
                <div className="border-b border-[#D7E4EB] mb-2 mt-[-10px]"></div>
                <div className="flex  mt-4 ml-5">
                  <div className="flex items-center">
                    <img
                      src={CommonImages.appStore}
                      alt="App Store"
                      className="h-2 w-2"
                    />
                    <p className="ml-2 text-[12px]">App store</p>
                  </div>
                  <div className="flex items-center ml-4">
                    <img
                      src={CommonImages.playStore}
                      alt="Play Store"
                      className="h-2 w-2"
                    />
                    <p className="ml-2 text-[12px]">Play store</p>
                  </div>
                </div>
                <div className="p-2 ">
                  {downfilteredIosList.length === 0 &&
                  downfilteredAndroidList.length === 0 ? (
                    <div className="flex justify-center items-center h-40">
                      <p className="text-gray-500 text-sm">
                        No download data available for this period
                      </p>
                    </div>
                  ) : (
                    <Chart
                      value={timeframe}
                      iosData={downfilteredIosList}
                      androidData={downfilteredAndroidList}
                    />
                  )}
                </div>
              </div>

              <div className="bg-[#F3F6F5] mt-[15px]">
                <div className="bg-white mb-10 rounded-2xl shadow-md m-2">
                  <div className="">
                    <p className="text-[14px] font-semibold ml-2 mt-[-5px] p-3">
                      Platforms
                    </p>
                  </div>
                  <div className="w-[100%] border-b border-[#D7E4EB] mb-4 m-0"></div>
                  <div className="text-center mb-4">
                    <p className="text-2xl font-bold mt-1">
                      {totalForPlatform}
                    </p>
                    <p className="text-[14px]">Total Downloads</p>
                  </div>
                  <div className="flex justify-center mb-10 m-5">
                    <ProgressBar segments={segments} />
                  </div>
                  <div className="flex justify-around m-4">
                    <SmallCard
                      image1={UserAuqisitation.appStoreIcon}
                      status={"App Store"}
                      count={downfilteredIosList.length}
                      rating={"+2.8%"}
                    />
                    <SmallCard
                      image1={UserAuqisitation.playStoreIcon}
                      status={"Play Store"}
                      count={loadingAndroidDownloads ? "..." : androidDownloads}
                      rating={loadingAndroidDownloads ? "" : "+0%"}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-[-10px]">
                {/* <CountryList countries={countries} title={"Countries"} /> */}
              </div>
            </div>
          )}

          {card === "2" && (
            <div className="h-screen w-full">
              <div className="bg-[#F3F6F5]">
                <div className="bg-white mb-3 rounded-2xl shadow-md m-2">
                  <div className="flex flex-row justify-between items-center m-2">
                    <p className="text-[14px] ml-3 mt-[-5px] font-semibold">
                      Registered Users
                    </p>

                    <CommonDropdown
                      options={options}
                      value={timeframe}
                      onChange={handleTimeframeChange}
                    />
                  </div>
                  <div className="border-b border-[#D7E4EB] mt-[-10px] mb-4"></div>
                  <div className="text-center mb-4">
                    <p className="text-2xl font-bold">{total}</p>
                    <p className="text-[14px]">Total registered Users</p>
                  </div>
                  <div className="flex justify-center mb-4 m-6">
                    <ProgressBar segments={segments2} />
                  </div>
                  <div className="flex justify-around m-4">
                    <SmallCard
                      image1={UserAuqisitation.nurseI}
                      status={"Nurses"}
                      count={filteredNurseList.length.toString()}
                      rating={"2378"}
                    />
                    <SmallCard
                      image1={UserAuqisitation.patientI}
                      status={"Patients"}
                      count={filteredPatientList.length.toString()}
                      rating={"784"}
                    />
                    <SmallCard
                      image1={UserAuqisitation.patientI}
                      status={"Physiotherapist"}
                      count={filteredPhysio.length.toString()}
                      rating={"784"}
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-row  mb-[60px] w-full ml-2 flex-wrap">
                <div className="w-1/2 pr-2">
                  <GeneralRole
                    values={timeframe}
                    nurseData={filteredNurseList}
                    patientData={filteredPatientList}
                    physioData={filteredPhysio}
                  />
                </div>

                <div className="w-1/2 pr-4 ">
                  <UserGender users={usersList} />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Home;
